module.exports = "<div class=thumb> <div class=cover></div> <div class=info><span class=page></span> / <%=nbPages%></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/page-slider-thumb-template.html
// module id = 67
// module chunks = 0